import type { PointsDialogSection } from "./points-dialog.tsx"

import * as UI from "@iyk/ui"
import * as React from "react"

import { toSentenceCase } from "@iyk/string"
import { useLang } from "../../lib/lang/use-lang.ts"
import { PointsDialog } from "./points-dialog.tsx"

const LOCALSTORAGE_POINTS_ONBOARDING_KEY = "points_onboarding"
const ONBOARDING_COMPLETED = "true"
const POINTS_ONBOARDING_VIDEO_URL = "https://assets.iyk-dev.app/points/rewards-intro-motion.mp4"

export const PointsOnboardingDialog = () => {
  const lang = useLang()

  const [open, setOpen] = React.useState(true)

  const handleOpenChangeDialog = (open: boolean) => {
    setOpen(open)
    if (!open) {
      setPointsOnboarding(true)
    }
  }

  return (
    <PointsDialog.Root open={open} onOpenChange={handleOpenChangeDialog}>
      <PointsDialog.Content headerHeight={240}>
        <UI.Media
          src={POINTS_ONBOARDING_VIDEO_URL}
          className="md:rounded-t-xl h-[240px] w-full object-cover"
        />
        <PointsDialog.ContentContainerBase className="gap-6">
          <PointsDialog.ContentSectionsBase sections={commonPointsDialogSections(lang)} />
          <UI.Button
            type="submit"
            kind="solid"
            size="md"
            className="sticky bottom-0"
            onClick={() => handleOpenChangeDialog(false)}
          >
            {toSentenceCase(lang.terms.GOT_IT)}
          </UI.Button>
        </PointsDialog.ContentContainerBase>
      </PointsDialog.Content>
    </PointsDialog.Root>
  )
}

export function usePointsOnboarding() {
  const [showPointsOnboardingDialog, setShowPointsOnboardingDialog] = React.useState(false)

  React.useEffect(() => {
    const pointsOnboarding = localStorage.getItem(LOCALSTORAGE_POINTS_ONBOARDING_KEY)

    if (pointsOnboarding !== ONBOARDING_COMPLETED) {
      setShowPointsOnboardingDialog(true)
    }
  }, [])

  return {
    showPointsOnboardingDialog,
  }
}

function setPointsOnboarding(value: boolean) {
  localStorage.setItem(LOCALSTORAGE_POINTS_ONBOARDING_KEY, value.toString())
}

const commonPointsDialogSections = (lang: ReturnType<typeof useLang>): PointsDialogSection[] => [
  {
    id: "points-are-here",
    title: toSentenceCase(lang.terms.POINTS_ONBOARDING_DIALOG_ARE_HERE),
    description: toSentenceCase(lang.terms.POINTS_ONBOARDING_DIALOG_ARE_HERE_DESCRIPTION),
  },
  {
    id: "refer-and-earn",
    title: toSentenceCase(lang.terms.POINTS_ONBOARDING_DIALOG_REFER_AND_EARN),
    description: toSentenceCase(lang.terms.POINTS_ONBOARDING_DIALOG_REFER_AND_EARN_DESCRIPTION),
  },
  {
    id: "redeem-in-the-shop",
    title: toSentenceCase(lang.terms.POINTS_ONBOARDING_DIALOG_REDEEM_IN_THE_SHOP),
    description: toSentenceCase(lang.terms.POINTS_ONBOARDING_DIALOG_REDEEM_IN_THE_SHOP_DESCRIPTION),
  },
]
